// ui/AnimatedButton.js
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@mui/material";

const AnimatedButton = ({ children, onClick, variant = "gradient", size = "large", ...props }) => {
  const getButtonStyles = () => {
    switch (variant) {
      case "gradient":
        return {
          background: "linear-gradient(45deg, #00ff88, #0099ff)",
          color: "#000814",
          fontWeight: 700,
          borderRadius: "50px",
          px: 4,
          py: 1.5,
          fontSize: size === "large" ? "1.1rem" : "1rem",
          "&:hover": {
            background: "linear-gradient(45deg, #00ff88, #0099ff)",
            transform: "translateY(-2px)",
          },
        };
      case "outline":
        return {
          background: "transparent",
          color: "#00ff88",
          border: "2px solid #00ff88",
          fontWeight: 700,
          borderRadius: "50px",
          px: 4,
          py: 1.5,
          fontSize: size === "large" ? "1.1rem" : "1rem",
          "&:hover": {
            background: "#00ff88",
            color: "#000814",
            border: "2px solid #00ff88",
          },
        };
      default:
        return {};
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <Button
        onClick={onClick}
        variant="contained"
        sx={getButtonStyles()}
        {...props}
      >
        {children}
      </Button>
    </motion.div>
  );
};

export default AnimatedButton;